export const brandStory = {
  // Hero Section
  hero: {
    label: 'OUR BRAND STORY',
    title: 'Where Heritage,\nPrecision, and\nVision Meet',
    intro: 'LUCENDO was created with a singular belief: true quality is born where heritage, precision, and vision meet.',
    paragraph1: 'Owned by MIACCENDO (MİACCENDO GIDA SANAYİ VE TİCARET LİMİTED ŞİRKETİ), Lucendo stands as a refined expression of global expertise in premium food and beverage solutions. Backed by MIACCENDO strategic strength, industry knowledge, and commitment to excellence, Lucendo brings together the finest traditions of production with modern innovation.',
    paragraph2: 'We are not defined by one origin — we are elevated by many.',
  },
  
  // Heritage Cards
  heritage: {
    italy: {
      title: 'ROOTED IN ITALY',
      paragraph1: 'At the heart of LUCENDO lies our Italian coffee, proudly produced in Italy — the world\'s most revered home of coffee culture.',
      paragraph2: 'Crafted by experienced roasters and guided by generations of expertise, our coffee reflects Italy\'s timeless mastery: rich aroma, balanced body, and unmistakable character. Every blend is a tribute to authenticity, precision, and the ritual of excellence that defines Italian coffee craftsmanship.',
    },
    turkey: {
      title: 'ENGINEERED IN TÜRKIYE',
      paragraph: 'LUCENDO\'s extended product portfolio is manufactured in Türkiye, a country known for its advanced food production capabilities and commitment to innovation. Our milkshakes, glazes, sauces, and HoReCa solutions are produced under rigorous quality standards to ensure premium taste, consistency, and performance. Developed for professional environments, these products deliver reliable results, refined flavor profiles, and flexible options for private label and customized applications. Türkiye\'s manufacturing excellence enables us to achieve a balance of efficiency and uncompromising quality, meeting the evolving needs of HoReCa professionals worldwide.',
    },
  },
  
  // Closing Statement
  closing: {
    quote: 'Two nations. One vision. Uncompromising excellence.',
  },
};
